import { useEffect, useState } from 'react';
import { useTwilio } from '../contexts/TwilioContext';

/**
 * Hook personalizado para manejar las funcionalidades de llamadas de Twilio
 * La inicialización ahora es automática y global a través del TwilioProvider
 */
export const useTwilioCall = () => {
  const { 
    isDeviceReady,
    incomingCall,
    activeCall,
    activeCalls,
    isMuted,
    makeCall,
    acceptCall,
    rejectCall,
    hangUp,
    toggleMute
  } = useTwilio();
  
  // Estado para UI de llamada entrante
  const [incomingNumber, setIncomingNumber] = useState(null);
  const [activeCallInfo, setActiveCallInfo] = useState(null);
  
  useEffect(() => {
    if (incomingCall) {
      setIncomingNumber(incomingCall.parameters?.From || null);
    } else {
      setIncomingNumber(null);
    }
  }, [incomingCall]);
  
  // Obtener información de la llamada activa
  useEffect(() => {
    if (activeCalls && activeCalls.length > 0) {
      // Obtener la primera llamada activa con información de contacto
      const firstActive = activeCalls[0];
      setActiveCallInfo(firstActive);
    } else {
      setActiveCallInfo(null);
    }
  }, [activeCalls]);

  /**
   * Realiza una llamada a un número específico
   * @param {string} phoneNumber - Número de teléfono a llamar
   */
  const callPhoneNumber = async (phoneNumber) => {
    console.log('=== DEBUG CALL PHONE NUMBER ===');
    console.log('📞 Número a llamar:', phoneNumber);
    console.log('🔧 Device ready:', isDeviceReady);
    console.log('🔧 makeCall function:', typeof makeCall);
    
    if (!phoneNumber) {
      console.error('❌ Número de teléfono requerido para realizar la llamada');
      return;
    }

    console.log(' Llamando a makeCall...');
    try {
      await makeCall(phoneNumber);
      console.log('✅ makeCall completado');
    } catch (error) {
      console.error('❌ Error en makeCall:', error);
      throw error;
    } finally {
      console.log('=== FIN DEBUG CALL PHONE NUMBER ===');
    }
  };

  /**
   * Estado de la llamada actual y métodos para UI
   */
  return {
    isDeviceReady,
    hasIncomingCall: !!incomingCall,
    hasActiveCall: !!activeCall,
    isMuted,
    incomingCallFrom: incomingNumber,
    activeCallWith: activeCall?.parameters?.To || activeCall?.parameters?.From,
    activeCallInfo: activeCallInfo, // ✨ Nueva: Información completa de la llamada activa
    call: callPhoneNumber,
    accept: acceptCall,
    reject: rejectCall,
    hangUp,
    toggleMute
  };
};